import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { isValidEmail } from '../../../shared/util';
import { MediaQuery as MQ } from '../../../shared/media-query';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../../shared/form/input-group')
);
const SelectGroup = lazy(
    () => import(/* webpackChunkName: "select-group" */ '../../../shared/form/select-group')
);
const CheckboxGroup = lazy(
    () => import(/* webpackChunkName: "checkbox-group" */ '../../../shared/form/checkbox-group')
);
const PhoneInput = lazy(
    () => import(/* webpackChunkName: "" */ 'react-phone-input-2')
);
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getBirthDate, months, days, date_to_sign_name } from '../../../shared/util';
import { getJSON } from '../../../shared/util-fetch';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.devcat = MQ.isMobile() ? 'Mobile' : 'Desktop';
        this.ctx = (props.signupIntent && props.signupIntent.ctx)
            ? props.signupIntent.ctx
            : (window.location.href.includes('readings-reports') ? 'reading' : 'nav');

        if (props.user && props.user.logged_in) {
            props.close();
        } else {
            this._initSignupState(props);
        }
    }

    _shortReadingSignup(props) {
        const intentNotBenefits = props.signupIntent && props.signupIntent.onSuccess !== 'benefits';
        const shortFlow = intentNotBenefits || (props.product && props.product.pending);

        if (!shortFlow || !props.product || !props.product.pending) {
            return false;
        }

        const productType = (props.product.teeup && props.product.teeup.product_type) ||
            (props.product.description && props.product.description.product_type);

        return productType === 'tarot';
    }

    _initSignupState(props) {
        props.trackEvent([
            'Open',
            'SiteInteraction:NewSignup',
        ]);

        this.years = [];
        for (let y = 16; y <= 101; y++) {
            this.years.push(dayjs().subtract(y, 'year').format('YYYY'));
        }

        // Interests will be loaded from API in componentDidMount
        this.interests = [];

        this.signData = {
            aries: {
                symbol: '♈',
                description: 'Welcome Aries, you just brought the spark we needed to get things moving.',
            },
            taurus: {
                symbol: '♉',
                description: 'Welcome Taurus, we\'ve saved you a cozy spot; ' +
                        'things are better when you\'re grounded here.',
            },
            gemini: {
                symbol: '♊',
                description: 'Welcome Gemini, good timing, we were just debating both sides of something.',
            },
            cancer: {
                symbol: '♋',
                description: 'Welcome Cancer, your intuition just synced perfectly with the energy here.',
            },
            leo: {
                symbol: '♌',
                description: 'Welcome Leo, go ahead, take the spotlight. You wear it well.',
            },
            virgo: {
                symbol: '♍',
                description: 'Welcome Virgo, the system already feels more organized now that you’re here.',
            },
            libra: {
                symbol: '♎',
                description: 'Welcome Libra, balance restored. We were teetering a little before you arrived.',
            },
            scorpio: {
                symbol: '♏',
                description: 'Welcome Scorpio, we were just hoping for someone who could handle depth.',
            },
            sagittarius: {
                symbol: '♐',
                description: 'Welcome Sagittarius, adventure approved. We’ve got plenty to explore.',
            },
            capricorn: {
                symbol: '♑',
                description: 'Welcome Capricorn, perfect timing. We needed someone with plans and follow-through.',
            },
            aquarius: {
                symbol: '♒',
                description: 'Welcome Aquarius, your originality just updated the whole vibe.',
            },
            pisces: {
                symbol: '♓',
                description: 'Welcome Pisces, the dreamers are gathering, and now it feels complete.',
            },
        };

        // If user has both email and password (coming from account-not-exists), start at step 2
        const initialMode = (props.user && props.user.email && props.user.password) ? 2 : 1;

        // Short flow (2 steps): intent is reload/navigate/close, or in-product (product.pending)
        const intentNotBenefits = props.signupIntent && props.signupIntent.onSuccess !== 'benefits';
        this.shortFlow = intentNotBenefits || (props.product && props.product.pending);
        this.shortReadingSignup = this._shortReadingSignup(props);

        this.state = {
            mode: initialMode,
            email: {
                value: props.user && props.user.email,
                error: null,
            },
            password: {
                value: props.user && props.user.password || null,
                error: null,
            },
            name: {
                value: props.user && props.user.name || null,
                error: null,
            },
            birthdate: {
                value: '',
                error: null,
            },
            birthdateMonth: {
                value: '',
                error: null,
            },
            birthdateDay: {
                value: '',
                error: null,
            },
            birthdateYear: {
                value: '',
                error: null,
            },
            agree: {
                value: false,
                error: null,
            },
            newsletter_optin: {
                value: false,
            },
            selectedInterests: [],
            telephone: {
                value: '',
                error: null,
            },
            smsAgree: {
                checked: false,
                error: null,
            },
            smsButtonDisabled: true,
            hasLoggedSignupView: false,
            hasLoggedProfileView2: false,
            hasLoggedProfileView3: false,
            hasLoggedSmsOptInView: false,
            signup_method: null,
            calculatedSign: null,
            isSubmitting: false,
        };
    }

    get meth() {
        return this.state.signup_method || 'button';
    }

    componentDidMount() {
        this.initializeGoogleSignIn();

        this.initializeAppleSignIn();

        this.loadInterests();

        // Notify parent of initial mode
        if (this.props.onModeChange) {
            this.props.onModeChange(this.state.mode);
        }

        // Long flow only: set intent with returnUrl so benefits redirect can offer "return to what you were doing"
        if (!this.shortFlow) {
            const intent = this.props.signupIntent;
            if (!intent || intent.onSuccess === 'benefits') {
                const returnUrl = window.location.pathname + window.location.search || '/';
                this.props.setSignupIntent({ onSuccess: 'benefits', returnUrl });
            }
        }
    }

    componentDidUpdate(prevProps) { // eslint-disable-line complexity
        // If backend returned a phone number error, keep user on step 4 and show error
        if (this.props.phoneNumberError && this.props.phoneNumberError !== prevProps.phoneNumberError) {
            this.setState({
                mode: 4,
                telephone: {
                    value: this.state.telephone.value,
                    error: this.props.phoneNumberError,
                },
                smsButtonDisabled: true,
                isSubmitting: false,
            });
            if (this.props.onModeChange) this.props.onModeChange(4);
        }

        // Handle SMS opt-in error from API (when SMS opt-in fails)
        if (this.state.mode === 4) {
            const smsError = this.props.user && this.props.user.sms && this.props.user.sms.error;
            const prevSmsError = prevProps.user && prevProps.user.sms && prevProps.user.sms.error;

            if (smsError && smsError !== prevSmsError) {
                // Clear any local telephone error and let renderSmsOptInError handle the API error
                this.setState({
                    telephone: {
                        value: this.state.telephone.value,
                        error: null, // Clear local validation error, API error will show separately
                    },
                    isSubmitting: false,
                });
            }

            // Check if SMS opt-in completed successfully (no error, and sms object exists with view === 2)
            const sms = this.props.user && this.props.user.sms;
            const prevSms = prevProps.user && prevProps.user.sms;
            if (sms && !sms.error && sms.view === 2 && (!prevSms || prevSms.view !== 2)) {
                // SMS opt-in completed successfully - complete signup flow
                this.completeSignupFlow();
            }
        }

        // If login attempt found member not found, proceed to signup step 2
        if (this.props.user && this.props.user.proceedToSignup &&
            (!prevProps.user || !prevProps.user.proceedToSignup)) {
            this.setState({ mode: 2 });
            if (this.props.onModeChange) this.props.onModeChange(2);
            // Clear the proceedToSignup flag
            this.props.userUpdate({ proceedToSignup: false });
        }

        // Handle signup API response at step 2
        if (this.state.mode === 2) {
            const user = this.props.user;
            const prevUser = prevProps.user;

            // Check if signup succeeded (user became logged in)
            if (user && user.logged_in && (!prevUser || !prevUser.logged_in)) {
                if (this.shortFlow) {
                    this.setState({ isSubmitting: false });
                    this.applySignupIntentAfterSignup();
                    return;
                }

                this.setState({
                    isSubmitting: false,
                    mode: 3, // Move to step 3 on success
                });
                if (this.props.onModeChange) this.props.onModeChange(3);
            }
            // Check if signup failed (submitting changed from true to false and errors exist)
            else if (user && user.submitting === false && prevUser && prevUser.submitting === true) {
                const emailError = this.props.emailError || user.emailError;
                const passwordError = this.props.passwordError || user.passwordError;
                const birthDateError = user.birthDateError;

                if (emailError || passwordError || birthDateError) {
                    const errorState = { isSubmitting: false };

                    if (emailError) {
                        errorState.email = { value: this.state.email.value, error: emailError };
                    }
                    if (passwordError) {
                        errorState.password = { value: this.state.password.value, error: passwordError };
                    }
                    if (birthDateError) {
                        errorState.birthdateMonth = { value: this.state.birthdateMonth.value, error: birthDateError };
                        errorState.birthdateDay = { value: this.state.birthdateDay.value, error: birthDateError };
                        errorState.birthdateYear = { value: this.state.birthdateYear.value, error: birthDateError };
                    }

                    this.setState(errorState);
                }
            }
            // Sync submitting state
            else if (user && user.submitting !== undefined) {
                if (user.submitting !== this.state.isSubmitting) {
                    this.setState({ isSubmitting: user.submitting });
                }
            }
        }

        // Reset submitting state when user becomes logged in (step 4 submission complete)
        if (this.props.user && this.props.user.logged_in && this.state.isSubmitting && this.state.mode === 4) {
            this.setState({ isSubmitting: false });
        } else if (this.props.user && this.props.user.submitting !== undefined && this.state.mode === 4) {
            // Sync with saga's submitting state for step 4
            // Only update if the prop actually changed from previous props to prevent infinite loops
            const prevSubmitting = prevProps.user && prevProps.user.submitting !== undefined
                ? prevProps.user.submitting
                : undefined;
            if (this.props.user.submitting !== prevSubmitting &&
                this.props.user.submitting !== this.state.isSubmitting) {
                this.setState({ isSubmitting: this.props.user.submitting });
            }
        }


    }


    initializeGoogleSignIn = () => {
        const maxRetries = 3;
        const retryDelay = 500; // 500ms
        let retryCount = 0;

        const tryInitializeGoogle = () => {
            if (window.google && window.google.accounts && window.google.accounts.id) {
                window.google.accounts.id.initialize({
                    client_id: this.props.google && this.props.google.client_id,
                    callback: this.googleSignup,
                    auto_select: false,
                    context: 'signin',
                    ux_mode: 'popup',
                });

                window.google.accounts.id.renderButton(
                    document.getElementById('google-signin-button'),
                    {
                        type: 'standard',
                        theme: 'outline',
                        size: 'large',
                        text: 'signin',
                        shape: 'rectangular',
                        logo_alignment: 'left',
                        width: '100',
                    }
                );
            } else if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(tryInitializeGoogle, retryDelay);
            }
        };

        tryInitializeGoogle();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.user != this.props.user) {
            return true;
        }

        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        const userJustSignedUp = this.props.user && this.props.user.logged_in;
        const applyingIntentOnClose = userJustSignedUp &&
            this.props.signupIntent &&
            (this.state.mode === 3 || this.state.mode === 4);
        const reportFlowClosing = userJustSignedUp && this.props.product && this.props.product.pending;

        if (applyingIntentOnClose) {
            // finish signup if user ends 4-step flow early
            this.applySignupIntentAfterSignup();
        }

        if (!applyingIntentOnClose && !reportFlowClosing) {
            this.props.userUpdate({
                emailError: null,
                passwordError: null,
            });
        }
    }

    initializeAppleSignIn = () => {
        // Check if Apple ID is available and initialize
        if (window.AppleID && window.AppleID.auth) {
            window.AppleID.auth.init({
                clientId: this.props.apple && this.props.apple.client_id,
                scope: 'name email',
                redirectURI: window.location.origin,
                usePopup: true,
            });
        }
    }

    render({
        emailError,
        passwordError,
        user,
    }, {
        mode,
        email,
        password,
        name,
        birthdateMonth,
        birthdateDay,
        birthdateYear,
        agree,
        newsletter_optin,
        selectedInterests,
        telephone,
        smsAgree,
        calculatedSign,
        isSubmitting,
    }) {
        // Allow modal to stay open during steps 3 and 4 even if user is logged in
        // (signup happens at step 2, but we want to complete steps 3 and 4)
        const shouldShowModal = !user || !user.logged_in || mode === 3 || mode === 4;

        if (shouldShowModal) {
            return (
                <signup-modal>
                    <row className='has-padding-15'>
                        {this.renderLeftColumn(
                            mode,
                            name,
                            birthdateMonth,
                            birthdateDay,
                            birthdateYear,
                            agree,
                            newsletter_optin,
                            selectedInterests,
                            telephone,
                            smsAgree,
                            password,
                            email,
                            emailError,
                            passwordError,
                            isSubmitting
                        )}
                        {this.renderRightColumn(mode, calculatedSign, name)}
                    </row>
                </signup-modal>
            );
        }

        return null;
    }

    renderDialogHeader = (title, subtitle, stepNumber) => {
        return (
            <dialog-header>
                <row className='has-margin-15-bottom'>
                    <column className='is-6 signup-logo'>
                        <img
                            src='https://gfx.tarot.com/images/navigation/icons/navigation-icons-newlogo-full.svg' // eslint-disable-line max-len
                            alt='Tarot.com'
                        />
                    </column>
                    <button className='close-icon' onClick={() => this.props.close('x', this.state.mode)} />
                </row>
                <div className='progress-indicator'>
                    <div className='progress-bar'>
                        {(this.shortFlow ? [1, 2] : [1, 2, 3, 4]).map((step) => (
                            <div
                                key={step}
                                className={`progress-step ${step === stepNumber ? 'active' : ''}`}
                            />
                        ))}
                    </div>
                </div>
                {stepNumber === 3 && (
                    <div className='signup-success-message'>
                        Your account has been created!
                    </div>
                )}
                <h1 className='signup-title' dangerouslySetInnerHTML={{ __html: title }} />
                <p
                    className='signup-subtitle'
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                />
            </dialog-header>
        );
    }

    renderLeftColumn = ( // eslint-disable-line complexity
        mode,
        name,
        birthdateMonth,
        birthdateDay,
        birthdateYear,
        agree,
        newsletter_optin,
        selectedInterests,
        telephone,
        smsAgree,
        password,
        email,
        emailError,
        passwordError,
        isSubmitting
    ) => { // eslint-disable-line complexity
        if (mode == 1) {
            if (!this.state.hasLoggedSignupView) {
                this.props.trackCustomEvent({
                    event_name: 'sign_up_view',
                    params: {
                        step: '1',
                        devcat: this.devcat,
                        ctx: this.ctx,
                        signup_url: window.location.pathname,
                    },
                });

                this.setState({ hasLoggedSignupView: true });
            }
            let title = 'We\'re in this with you.';
            let subtitle = '<b>Create a free account</b>—it\'s how we save your readings, ' +
                'personalize your insights, and keep the fun going.';
            let button_text = 'Next';
            if (this.shortReadingSignup) {
                title = 'Your first reading is ready!';
                subtitle = '<b>Create a secure login </b>to save these cards to your journal and uncover your ' +
                    'personal patterns and emotional levers over time. You\'ll even get ' +
                    '<b>🎁 50% off a premium reading</b> so you can go deeper when you\'re ready.';
            }

            return [
                <column className='is-2-tablet is-hidden-mobile is-hidden-desktop' />,
                <column className='is-12-mobile is-8-tablet is-4'>
                    {this.renderDialogHeader(title, subtitle, 1)}
                    <dialog-content>
                        <form autoComplete='on' onSubmit={this.validate}>
                            <row>
                                <column className='is-12'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <InputGroup
                                            autoFocus
                                            type='email-placeholder'
                                            name='email'
                                            placeholder='Email'
                                            value={email.value}
                                            error={email.error || emailError}
                                            onInput={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                            </row>
                            <row className='has-margin-10-bottom'>
                                <column className='is-12'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <InputGroup
                                            type='password-placeholder'
                                            name='password'
                                            placeholder='Password'
                                            value={password.value}
                                            error={password.error || passwordError}
                                            onInput={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                            </row>
                            <row>
                                <column className='is-12 has-text-center'>
                                    <button
                                        className='next-button'
                                        onClick={this.validate}
                                    >
                                        {button_text}
                                    </button>
                                </column>
                            </row>
                            <row>
                                <column className='is-12'>
                                    <div className='separator'>
                                        <span>or continue with</span>
                                    </div>
                                </column>
                            </row>
                            <row>
                                <column className='is-12'>
                                    <div className='sso-buttons'>
                                        <div id='google-signin-button' />
                                        <button
                                            type='button'
                                            className='sso-button facebook'
                                            onClick={this.facebookSignup}
                                        >
                                            <span className='sso-icon' />
                                            Facebook
                                        </button>
                                        <button
                                            type='button'
                                            className='sso-button apple'
                                            onClick={this.appleSignup}
                                        >
                                            <span className='sso-icon' />
                                            Apple
                                        </button>
                                    </div>
                                </column>
                            </row>
                            <row>
                                <column className='is-12'>
                                    <p className='login-link'>
                                        Already have an account? <a href='#login'>Log in here.</a>
                                    </p>
                                </column>
                            </row>
                        </form>
                    </dialog-content>
                </column>,
            ];
        } else if (mode == 2) {
            if (!this.state.hasLoggedProfileView2) {
                this.props.trackCustomEvent({
                    event_name: 'sign_up_view',
                    params: {
                        step: '2',
                        devcat: this.devcat,
                        ctx: this.ctx,
                        signup_url: window.location.pathname,
                    },
                });

                this.setState({ hasLoggedProfileView2: true });
            }
            let title = 'Great! Your Reading Journal is Ready';
            let subtitle = 'Enter your <b>birth date</b> to align your readings and journal with the universe’s timing and make every moment here more meaningful.'; // eslint-disable-line max-len
            let button_text = 'Sign Up';
            if (this.shortReadingSignup) {
                title = 'Karmic Checkpoint.';
                subtitle = 'We take our <b>karmic footprint seriously.</b> We need your birth date to keep this ' +
                    'space safe (and verify you’re 16+). It also lets us sync your sun sign to your new journal. ' +
                    '<i>Your first entry is waiting.</i>';
                button_text = 'Save and See my Reading';
            }

            return [
                <column className='is-2-tablet is-hidden-mobile is-hidden-desktop' />,
                <column className='is-12-mobile is-8-tablet is-4'>
                    {this.renderDialogHeader(title, subtitle, 2)}
                    <dialog-content>
                        <form autoComplete='on' onSubmit={this.validate}>
                            <row>
                                <column className='is-12'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <InputGroup
                                            autoFocus
                                            type='text-placeholder'
                                            name='name'
                                            placeholder='Name'
                                            value={name.value}
                                            error={name.error}
                                            onInput={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                            </row>
                            <row className='is-wrap'>
                                <column className='is-6 has-padding-10-right'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <SelectGroup
                                            name='birthdateMonth'
                                            placeholder='Month'
                                            options={months}
                                            value={birthdateMonth.value}
                                            error={birthdateMonth.error}
                                            onChange={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                                <column className='is-3 has-padding-10-right'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <SelectGroup
                                            name='birthdateDay'
                                            placeholder='Day'
                                            options={days}
                                            value={birthdateDay.value}
                                            error={birthdateDay.error}
                                            onChange={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                                <column className='is-3'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <SelectGroup
                                            name='birthdateYear'
                                            placeholder='Year'
                                            options={this.years}
                                            value={birthdateYear.value}
                                            error={birthdateYear.error}
                                            onChange={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                            </row>
                            <row>
                                <column className='is-12'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <CheckboxGroup
                                            name='newsletter_optin'
                                            value='1'
                                            label='Get my <b>free</b> horoscope emails'
                                            checked={newsletter_optin.value}
                                            onChange={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                            </row>
                            <row className='agree_row'>
                                <column className='is-12'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <CheckboxGroup
                                            name='agree'
                                            value='1'
                                            ppcLabel
                                            checked={agree.value}
                                            error={agree.error}
                                            onChange={this.setFormValues}
                                        />
                                    </Suspense>
                                </column>
                            </row>
                            <row>
                                <column className='is-12 has-text-center'>
                                    <button
                                        className='next-button'
                                        onClick={this.validate}
                                        disabled={isSubmitting}
                                    >
                                        {button_text}
                                    </button>
                                </column>
                            </row>
                        </form>
                    </dialog-content>
                </column>,
            ];
        } else if (mode == 3) {
            if (!this.state.hasLoggedProfileView3) {
                this.props.trackCustomEvent({
                    event_name: 'sign_up_view',
                    params: {
                        step: '3',
                        devcat: this.devcat,
                        ctx: this.ctx,
                        signup_url: window.location.pathname,
                    },
                });

                this.setState({ hasLoggedProfileView3: true });
            }
            let title = 'What brings you here?';
            let subtitle = 'Choose a few areas where you\'d like more <b>clarity or control</b>. We\'ll use them to guide your feed (and you can always update later).'; // eslint-disable-line max-len
            let button_text = 'Take the Next Step';

            return [
                <column className='is-2-tablet is-hidden-mobile is-hidden-desktop' />,
                <column className='is-12-mobile is-8-tablet is-4'>
                    {this.renderDialogHeader(title, subtitle, 3)}
                    <dialog-content>
                        <form autoComplete='on' onSubmit={this.validate}>
                            <row>
                                <column className='is-12'>
                                    <div className='interest-chips'>
                                        {this.interests.map((interest, index) => (
                                            <button
                                                key={index}
                                                type='button'
                                                className={
                                                    `interest-chip ${selectedInterests.includes(interest)
                                                        ? 'selected' : ''}`
                                                }
                                                onClick={() => this.toggleInterest(interest)}
                                            >
                                                {interest}
                                            </button>
                                        ))}
                                    </div>
                                </column>
                            </row>
                            <row className='has-margin-20-bottom'>
                                <column className='is-12 has-text-center'>
                                    <button className='next-button' onClick={this.validate}>{button_text}</button>
                                </column>
                            </row>
                            <row>
                                <column className='is-12 has-text-center'>
                                    <a
                                        href='#' onClick={(e) => {
                                            e.preventDefault();
                                            this.props.trackCustomEvent({
                                                event_name: 'interest_skip',
                                                params: {
                                                    devcat: this.devcat,
                                                    ctx: this.ctx,
                                                },
                                            });
                                            this.setState({ mode: 4, isSubmitting: false });
                                            if (this.props.onModeChange) this.props.onModeChange(4);
                                        }}
                                    >
                                        Maybe Later
                                    </a>
                                </column>
                            </row>
                        </form>
                    </dialog-content>
                </column>,
            ];
        } else if (mode == 4) {
            if (!this.state.hasLoggedSmsOptInView) {
                this.props.trackCustomEvent({
                    event_name: 'sign_up_view',
                    params: {
                        step: '4',
                        devcat: this.devcat,
                        ctx: this.ctx,
                        signup_url: window.location.pathname,
                    },
                });

                this.setState({ hasLoggedSmsOptInView: true });
            }
            let title = 'Sign up for Cosmic Texts and <b>get 50% off</b> any reading!*';
            let subtitle = 'Enter Your Mobile Number (US Only)';
            let button_text = 'Complete Signup & Claim My Discount';

            return [
                <column className='is-2-tablet is-hidden-mobile is-hidden-desktop' />,
                <column className='is-12-mobile is-8-tablet is-4'>
                    {this.renderDialogHeader(title, subtitle, 4)}
                    <dialog-content>
                        <form autoComplete='on' onSubmit={this.validate}>
                            <row className='is-wrap'>
                                <column className='is-12'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <PhoneInput
                                            country='us'
                                            onlyCountries={['us']}
                                            onChange={phone => this.setTelephone(phone)}
                                            placeholder='+1 (999) 555-1234'
                                            value={telephone.value}
                                            containerClass={
                                                telephone.error ||
                                                (this.props.user && this.props.user.sms && this.props.user.sms.error)
                                                    ? 'has-error'
                                                    : null
                                            }
                                        />
                                    </Suspense>
                                    {telephone.error && (
                                        <p className='is-error'>{telephone.error}</p>
                                    )}
                                    {this.renderSmsOptInError()}
                                </column>
                            </row>
                            <row className='has-margin-15-top'>
                                <column className='is-1 is-2-mobile'>
                                    <Suspense fallback={<div className='skeleton' />}>
                                        <CheckboxGroup
                                            name='smsAgree'
                                            checked={smsAgree.checked}
                                            onChange={this.setAgree}
                                        />
                                    </Suspense>
                                </column>
                                <column className='is-11 is-10-mobile'>
                                    <p className='has-text-size-12 has-line-height-19 sms-text'>
                                        Yes, text me insights + special offers. Occasional alerts.
                                        Msg/data rates may apply. STOP to unsubscribe. {' '}
                                        <a
                                            href='/terms-of-use'
                                            target='_blank'
                                        >
                                            Terms & Conditions
                                        </a> | <a
                                            href='/privacy-policy'
                                            target='_blank'
                                        > {/* eslint-disable-line react/jsx-closing-bracket-location */}
                                            Privacy Policy
                                        </a> {/* eslint-disable-line react/jsx-closing-tag-location */}
                                    </p>
                                    {this.renderAgreeError()}
                                </column>
                            </row>
                            <row>
                                <column className='is-12'>
                                    <p className='has-text-size-12 has-line-height-19'>
                                        * Offer valid for one reading after number verification.
                                    </p>
                                </column>
                            </row>
                            <row className='has-margin-20-bottom'>
                                <column className='is-12 has-text-center'>
                                    <button
                                        className='next-button'
                                        onClick={this.validate}
                                        disabled={this.state.smsButtonDisabled || isSubmitting}
                                    >
                                        {button_text}
                                    </button>
                                </column>
                            </row>
                            <row>
                                <column className='is-12 has-text-center'>
                                    <a
                                        href='#'
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (!isSubmitting) this.validate(e, true);
                                        }}
                                    >
                                        Skip for Now - I Can Add This Anytime
                                    </a>
                                </column>
                            </row>
                        </form>
                    </dialog-content>
                </column>,
            ];
        }

        return null;
    }

    renderRightColumn = (mode, calculatedSign, name) => {
        if (mode == 1) {
            return (
                <column className='is-hidden-mobile is-hidden-tablet is-8'>
                    <div className='signup-promo'>
                        <div className='video-container'>
                            <video
                                key={`video-mode-${mode}`}
                                autoPlay
                                muted
                                loop
                                playsInline
                                poster='https://gfx.tarot.com/images/signup/chart-and-cards-fallback.webp'
                            >
                                <source
                                    src='https://gfx.tarot.com/images/signup/chart-and-cards-vid.mp4'
                                    type='video/mp4'
                                />
                            </video>
                        </div>
                        <div className='promo-content'>
                            <h2 className='promo-title'>Free membership gives you:</h2>
                            <ul className='promo-benefits'>
                                <li>
                                    Receive <strong>50% off</strong> your first purchase
                                </li>
                                <li>
                                    Saved Tarot readings in your <strong>personal Journal</strong>
                                </li>
                                <li>
                                    <strong>Daily horoscopes</strong> + <strong>Tarot Card of the Day</strong>
                                </li>
                                <li>
                                    Your full <strong>Cosmic Profile</strong> (Sun, Moon, Rising, Life Path)
                                </li>
                                <li>A <strong>free birthday reading</strong>, just for you 🎂</li>
                            </ul>
                        </div>
                    </div>
                </column>
            );
        } else if (mode == 2) {
            return (
                <column className='is-hidden-mobile is-hidden-tablet is-8'>
                    <div className='signup-promo'>
                        <div className='video-container'>
                            <video
                                key={`video-mode-${mode}`}
                                autoPlay
                                muted
                                loop
                                playsInline
                                poster='https://gfx.tarot.com/images/signup/book-astro-chart-fallback.webp'
                            >
                                <source
                                    src='https://gfx.tarot.com/images/signup/book-astro-chart-vid.mp4'
                                    type='video/mp4'
                                />
                            </video>
                        </div>
                        <div className='promo-content step-2'>
                            {calculatedSign && (
                                <div className='calculated-sign-display'>
                                    <column className='daily-symbol has-text-center'>
                                        {this.signData[calculatedSign]?.symbol}
                                    </column>
                                    <h2 className='sign-name'>{calculatedSign.toUpperCase()}</h2>
                                    <p className='sign-description'>
                                        {this.signData[calculatedSign]?.description}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </column>
            );
        } else if (mode == 3) {
            return (
                <column className='is-hidden-mobile is-hidden-tablet is-8'>
                    <div className='signup-promo'>
                        <div className='video-container'>
                            <video
                                key={`video-mode-${mode}`}
                                autoPlay
                                muted
                                loop
                                playsInline
                                poster='https://gfx.tarot.com/images/signup/tarot-reader-fallback.webp'
                            >
                                <source
                                    src='https://gfx.tarot.com/images/signup/tarot-reader-vid.mp4'
                                    type='video/mp4'
                                />
                            </video>
                        </div>
                        <div className='promo-content step-3'>
                            <h2 className='promo-title'>Shape your path, {name.value}</h2>
                            <ul className='promo-benefits'>
                                <li>Unlock personalized readings, tailored insights, and guidance for your journey.</li>
                            </ul>
                        </div>
                    </div>
                </column>
            );
        } else if (mode == 4) {
            return (
                <column className='is-hidden-mobile is-hidden-tablet is-8'>
                    <div className='signup-promo'>
                        <div className='video-container'>
                            <video
                                key={`video-mode-${mode}`}
                                autoPlay
                                muted
                                loop
                                playsInline
                                poster='https://gfx.tarot.com/images/signup/phone-tarot-chart-fallback.webp'
                            >
                                <source
                                    src='https://gfx.tarot.com/images/signup/phone-tarot-chart-vid.mp4'
                                    type='video/mp4'
                                />
                            </video>
                        </div>
                        <div className='promo-content step-4'>
                            <h2 className='promo-title'>Fully dialed in...</h2>
                            <ul className='promo-benefits'>
                                <li>Regular insights</li>
                                <li>Occasional alerts</li>
                                <li>Delivered straight to your phone</li>
                                <li>No need to search</li>
                            </ul>
                        </div>
                    </div>
                </column>
            );
        }

        return null;
    }

    completeSignupFlow = () => {
        // Centralized function to complete signup flow and clear product.pending
        // Called when signup flow finishes (step 4 complete or early exit)
        if (this.props.product && this.props.product.pending) {
            this.props.updateProduct({
                pending: false,
            });
        }
    }

    applySignupIntentAfterSignup = () => {
        const wasProductPending = this.props.product && this.props.product.pending;
        this.completeSignupFlow();
        const intent = this.props.signupIntent;
        if (wasProductPending) {
            this.props.routeTo('');
            this.props.clearSignupIntent();
        } else if (intent && intent.onSuccess === 'navigate' && intent.url) {
            this.props.clearSignupIntent();
            window.location.href = intent.url;
        } else if (intent && intent.onSuccess === 'reload') {
            this.props.clearSignupIntent();
            window.location.reload();
        } else if (intent && intent.onSuccess === 'close') {
            this.props.routeTo('');
            this.props.clearSignupIntent();
        } else {
            const returnUrl = this.props.signupIntent && this.props.signupIntent.returnUrl;
            this.props.clearSignupIntent();

            if (returnUrl && returnUrl === '/member/benefits' && window.location.pathname === returnUrl) {
                window.location.reload();
                return;
            }

            const benefitsUrl = returnUrl
                ? `/member/benefits?return_url=${encodeURIComponent(returnUrl)}`
                : '/member/benefits';
            window.location.href = benefitsUrl;
        }
    }

    setFormValues = (e) => {
        let state = {};

        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change' || e.type == 'input') {
            if (['birthdateMonth', 'birthdateDay', 'birthdateYear'].includes(e.target.name)) {
                state = {
                    birthdateMonth: {
                        value: this.state.birthdateMonth.value,
                        error: null,
                    },
                    birthdateDay: {
                        value: this.state.birthdateDay.value,
                        error: null,
                    },
                    birthdateYear: {
                        value: this.state.birthdateYear.value,
                        error: null,
                    },
                };

                state[e.target.name].value = e.target.value;

                state.birthdate = {
                    value: getBirthDate(
                        state.birthdateMonth.value,
                        state.birthdateDay.value,
                        state.birthdateYear.value
                    ),
                    error: null,
                };

                // Calculate sign when month and day are filled
                this.calculateSign(state.birthdateMonth.value, state.birthdateDay.value);
            } else if (['privacy_policy', 'newsletter_optin', 'sms_optin', 'agree'].includes(e.target.name)) {
                state[e.target.name] = {
                    value: e.target.checked,
                    error: null,
                };

                if (e.target.name == 'newsletter_optin' && e.target.checked) {
                    this.props.trackCustomEvent({
                        event_name: 'newsletter_opt_in',
                        params: {
                            devcat: this.devcat,
                            ctx: this.ctx,
                            checked: 'true',
                        },
                    });
                }
            } else {
                state[e.target.name] = {
                    value: e.target.value,
                    error: null,
                };
            }

            this.setState(state);
        }
    }

    toggleInterest = (interest) => {
        const { selectedInterests } = this.state;
        const wasChecked = selectedInterests.includes(interest);
        const newSelectedInterests = wasChecked
            ? selectedInterests.filter(item => item !== interest)
            : [...selectedInterests, interest];

        this.setState({ selectedInterests: newSelectedInterests });
    }

    setTelephone = (value) => {
        this.setState({
            telephone: {
                value: value,
                error: null,
            },
        });
        this.updateSmsButtonState(value, this.state.smsAgree.checked);
    }

    setAgree = (e) => {
        const newChecked = e.target.checked;
        this.setState({
            smsAgree: {
                checked: newChecked,
                error: null,
            },
        });
        this.updateSmsButtonState(this.state.telephone.value, newChecked);

        // Send GA4 event when SMS opt-in checkbox is checked
        if (newChecked) {
            this.props.trackCustomEvent({
                event_name: 'sms_opt_in',
                params: {
                    devcat: this.devcat,
                    ctx: this.ctx,
                    checked: 'true',
                },
            });
        }
    }

    updateSmsButtonState = (phoneValue, smsChecked) => {
        const isValidPhone = phoneValue && phoneValue.match(/1[0-9]{10}/);
        const shouldEnableButton = isValidPhone && smsChecked;

        this.setState({
            smsButtonDisabled: !shouldEnableButton,
        });
    }

    renderAgreeError = () => {
        if (this.state.smsAgree.error) {
            return (<p className='is-error'>{this.state.smsAgree.error}</p>);
        }

        return null;
    }

    renderSmsOptInError = () => {
        const smsError = this.props.user && this.props.user.sms && this.props.user.sms.error;
        if (smsError) {
            return (<p className='is-error-multiline'>{smsError}</p>);
        }

        return null;
    }

    emailValidation = async (email) => {
        // First check if email format is valid
        if (!isValidEmail(email)) {
            return false;
        }

        try {
            await getJSON('/api/user/validate-email', { email: email });
            return true;
        } catch (error) {
            return false;
        }
    }

    loadInterests = async () => {
        // Fallback interests if API fails
        const fallbackInterests = [
            'Love & Relationships',
            'Fun',
            'Worries',
            'Money & Career',
            'Personal Growth',
            'Astrology',
            'Life Changes',
            'Spirituality',
            'Learn Tarot',
            'Grief & Healing',
            'Attract Luck',
            'Find Joy',
        ];

        try {
            // Get only signup interests from the Interest API
            const response = await getJSON('/api/member/get-interests', { signup: 'true' });
            if (response && Array.isArray(response)) {
                // Extract just the names for backward compatibility with existing logic
                this.interests = response.map(interest => interest.name);
                if (this.state.mode === 3) {
                    this.setState({ selectedInterests: this.state.selectedInterests });
                }
            }
        } catch (error) {
            this.interests = fallbackInterests;
            if (this.state.mode === 3) {
                this.setState({ selectedInterests: this.state.selectedInterests });
            }
        }
    }

    calculateSign = (month, day) => {
        if (month && day) {
            // Create a date string that can be parsed by date_to_sign_name
            // We'll use the current year as a placeholder since the function only needs month and day
            const currentYear = new Date().getFullYear();
            const birthdate = `${currentYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

            try {
                const signName = date_to_sign_name(birthdate);
                if (signName) {
                    this.setState({ calculatedSign: signName });
                }
            } catch (error) {
                // Error calculating sign, ignore
            }
        }
    }

    validate = (e, skipPhone = false) => { // eslint-disable-line complexity
        e.preventDefault();

        const currentMode = this.state.mode;

        if (currentMode === 1) {
            // Mode 1: Validate email and password
            this.props.trackCustomEvent({
                event_name: 'sign_up_start',
                params: {
                    devcat: this.devcat,
                    ctx: this.ctx,
                    meth: 'button',
                },
            });

            const state = {
                email: {
                    value: this.state.email.value,
                    error: null, // Will be set by async validation
                },
                password: {
                    value: this.state.password.value,
                    error: this.state.password.value ? this.validatePassword() : 'Please enter a password',
                },
            };

            this.setState(state);

            if (!state.password.error) {
                // Validate email via API, then attempt login first
                this.emailValidation(this.state.email.value).then((isValid) => {
                    if (isValid) {
                        this.props.userLogin({
                            email: this.state.email.value,
                            password: this.state.password.value,
                            fromSignup: true,
                        });
                    } else {
                        this.setState({
                            email: {
                                value: this.state.email.value,
                                error: 'Please enter a valid email',
                            },
                        });
                    }
                });
            }
        } else if (currentMode === 2) {
            // Mode 2: Validate name, birthdate, and agree
            const birthdateError = this.validateBirthdate();
            const state = {
                name: {
                    value: this.state.name.value,
                    error: this.validateNameLength(),
                },
                birthdate: {
                    value: this.state.birthdate.value,
                    error: birthdateError,
                },
                birthdateMonth: {
                    value: this.state.birthdateMonth.value,
                    error: birthdateError && !this.state.birthdateMonth.value ? 'Required' : null,
                },
                birthdateDay: {
                    value: this.state.birthdateDay.value,
                    error: birthdateError && !this.state.birthdateDay.value ? 'Required' : null,
                },
                birthdateYear: {
                    value: this.state.birthdateYear.value,
                    error: birthdateError && !this.state.birthdateYear.value ? 'Required' : null,
                },
                agree: {
                    value: this.state.agree.value || document.querySelector('input[name="agree"]').checked,
                    error: !this.state.agree.value && !document.querySelector('input[name="agree"]').checked ? 'Please accept before continuing' : null, // eslint-disable-line max-len
                },
            };

            if (state.agree.error) {
                this.props.trackCustomEvent({
                    event_name: 'sign_up_error',
                    params: {
                        devcat: this.devcat,
                        ctx: this.ctx,
                        meth: 'button',
                        error_type: 'agree_unchecked',
                    },
                });
            }

            this.setState(state);

            if (
                !state.name.error
                &&
                !state.birthdate.error
                &&
                !state.agree.error
                &&
                state.agree.value
            ) {
                // Prevent multiple submissions
                if (this.state.isSubmitting) {
                    return;
                }

                this.props.trackCustomEvent({
                    event_name: 'profile_submit',
                    params: {
                        devcat: this.devcat,
                        ctx: this.ctx,
                        dob_provided: 'true',
                        name_provided: 'true',
                    },
                });

                // Set submitting state before API call
                this.setState({ isSubmitting: true });

                // Create payload and submit signup
                let subscribe_lists = [
                    'birthday',
                    'content_page',
                    'ipe',
                    'kca',
                    'product_teeup',
                    'receipt',
                    'tarot_trigger',
                    'welcome',
                ];

                if (this.state.newsletter_optin.value) {
                    subscribe_lists = subscribe_lists.concat(
                        ['dailyhoroscope', 'dle', 'weekly_love']
                    );
                }

                let payload = {
                    first_name: this.state.name.value,
                    display_name: this.state.name.value,
                    email: this.state.email.value,
                    signup_gateway: 'signup',
                    signup_url: window.location.href,
                    account_type_id: 1,
                    birth_date: dayjs(this.state.birthdate.value).format('YYYY-MM-DD'),
                    timezone: (new Date().getTimezoneOffset() / 60) * -1,
                    subscribe_lists: subscribe_lists,
                    privacy_policy: true,
                };

                if (this.state.signup_method) {
                    payload.signup_method = this.state.signup_method;
                }

                if (this.state.password.value) {
                    payload.password = this.state.password.value;
                }

                // Submit signup - componentDidUpdate will handle success/error response
                this.props.userSignup(payload);
            }
        } else if (currentMode === 3) {
            // Mode 3: Validate interest chips, save to API, and move to mode 4
            const { selectedInterests } = this.state;
            const totalInterests = selectedInterests.length;
            const interestNames = selectedInterests;

            // Send GA4 event for interest submission
            this.props.trackCustomEvent({
                event_name: 'interest_submit',
                params: {
                    devcat: this.devcat,
                    ctx: this.ctx,
                    total_interests: totalInterests,
                    interest_names: interestNames,
                },
            });

            // Update interests via API
            if (selectedInterests.length > 0) {
                this.props.updateInterests({
                    interests: selectedInterests,
                    location: 'signup-modal',
                });
            }

            this.setState({ mode: 4, isSubmitting: false });
            if (this.props.onModeChange) this.props.onModeChange(4);
        } else if (currentMode === 4) {
            // Mode 4: Validate phone number and agree checkbox
            // Note: Signup already happened at step 2, this step will eventually call a separate API to update SMS
            // Prevent multiple submissions
            if (this.state.isSubmitting) {
                return;
            }

            let state = { error: false };

            if (skipPhone) {
                // Skip phone validation - user clicked "Maybe Later"
                this.props.trackCustomEvent({
                    event_name: 'sms_skip',
                    params: {
                        devcat: this.devcat,
                        ctx: this.ctx,
                    },
                });

                state.telephone = {
                    value: this.state.telephone.value,
                    error: null,
                };
                state.smsAgree = {
                    checked: false,
                    error: null,
                };

                this.setState({ ...this.state, ...state });

                this.applySignupIntentAfterSignup();
                return;
            } else if (!this.state.telephone.value) {
                // No phone number entered, so no validation needed
                state.telephone = {
                    value: this.state.telephone.value,
                    error: null,
                };
            } else if (!this.state.telephone.value.match(/1[0-9]{10}/)) {
                state.telephone = {
                    value: this.state.telephone.value,
                    error: 'Please enter a valid US phone number',
                };
                state.error = true;

                this.props.trackCustomEvent({
                    event_name: 'sign_up_error',
                    params: {
                        devcat: this.devcat,
                        ctx: this.ctx,
                        meth: this.meth,
                        error_type: 'invalid_phone',
                    },
                });

            } else {
                this.props.trackCustomEvent({
                    event_name: 'sms_opt_in_submit',
                    params: {
                        devcat: this.devcat,
                        ctx: this.ctx,
                        consent_checked: 'true',
                    },
                });

                state.telephone = {
                    value: this.state.telephone.value,
                    error: null,
                };
            }

            // Only require SMS agreement if phone number is entered and not skipping
            if (!skipPhone && this.state.telephone.value && !this.state.smsAgree.checked) {
                state.smsAgree = {
                    checked: this.state.smsAgree.checked,
                    error: 'Please agree before continuing',
                };
                state.error = true;
            } else {
                state.smsAgree = {
                    checked: skipPhone ? false : this.state.smsAgree.checked,
                    error: null,
                };
            }

            this.setState({ ...this.state, ...state });

            // Call SMS opt-in API if phone number is provided and not skipping
            if (!skipPhone && this.state.telephone.value && !state.error) {
                this.props.optIn({
                    phone_number: this.state.telephone.value,
                    location: 'signup-modal',
                    from_signup: true,
                });
            }
        }
    }

    validatePassword = () => {
        let error_message = null;
        if (this.state.password.value.length <= 3) {
            error_message = 'Please enter a password longer than 3 characters.';
        }

        if (error_message) {
            this.props.trackCustomEvent({
                event_name: 'sign_up_error',
                params: {
                    devcat: this.devcat,
                    ctx: this.ctx,
                    meth: this.meth,
                    error_type: 'invalid_password',
                },
            });
        }

        return error_message;
    }

    validateBirthdate = () => {
        let error_message = null;

        if (this.state.birthdate.value) {
            let birthdate = null;

            if (this.state.birthdate.value.match(/[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/)) {
                birthdate = dayjs(this.state.birthdate.value);
            } else if (this.state.birthdate.value.match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)) {
                birthdate = dayjs(this.state.birthdate.value);
            } else {
                error_message = 'Please enter a valid Birth Date: mm/dd/yyyy';
            }

            if (!error_message) {
                const sixteen_years_ago = dayjs().subtract(16, 'year').startOf('day');
                const one_hundred_years_ago = dayjs(`${this.years.slice(-1)[0]}-01-01`);

                if (!birthdate.isValid()) {
                    error_message = 'Please enter a valid Birth Date: mm/dd/yyyy';
                } else if (birthdate.isAfter(sixteen_years_ago)) {
                    error_message = 'You must be 16 years or older to signup.';
                } else if (birthdate.isBefore(one_hundred_years_ago)) {
                    error_message = `Please enter a Birth Date after ${one_hundred_years_ago.format('MM/DD/YYYY')}`;
                }
            }
        } else {
            error_message = 'Please enter your birth date';
        }

        if (error_message) {
            this.props.trackCustomEvent({
                event_name: 'sign_up_error',
                params: {
                    devcat: this.devcat,
                    ctx: this.ctx,
                    meth: this.meth,
                    error_type: 'invalid_birthdate',
                },
            });
        }

        return error_message;
    }

    validateNameLength = () => {
        let error_message = null;
        if (!this.state.name.value) {
            error_message = 'Please enter your name.';
        } else if (this.state.name.value.length > 63) {
            error_message = 'Please enter a name 63 characters or less.';
        }

        if (error_message) {
            this.props.trackCustomEvent({
                event_name: 'sign_up_error',
                params: {
                    devcat: this.devcat,
                    ctx: this.ctx,
                    meth: this.meth,
                    error_type: 'invalid_name',
                },
            });
        }

        return error_message;
    }

    trackClick = (info) => {
        this.props.trackEvent(['Click', info]);
    }

    decodeJwtResponse = (token) => {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    googleSignup = (response) => {
        this.props.trackCustomEvent({
            event_name: 'sign_up_start',
            params: {
                devcat: this.devcat,
                ctx: this.ctx,
                meth: 'google',
            },
        });

        const responsePayload = this.decodeJwtResponse(response.credential);
        const email = responsePayload.email;
        const name = responsePayload.name;

        this.setState({
            email: {
                value: email,
                error: null,
            },
            name: {
                value: name,
                error: null,
            },
            signup_method: 'google',
        });

        // Attempt login first, will proceed to signup if member not found
        this.props.userLogin({
            credential: response.credential,
            sso: 'google',
            email: email,
            fromSignup: true,
        });
    }

    facebookSignup = () => {
        this.props.trackCustomEvent({
            event_name: 'sign_up_start',
            params: {
                devcat: this.devcat,
                ctx: this.ctx,
                meth: 'facebook',
            },
        });

        if (window.FB) {
            window.FB.login((response) => {
                if (response.authResponse) {
                    window.FB.api(
                        '/me',
                        { fields: 'name,email' },
                        (profileResponse) => {
                            if (profileResponse && !profileResponse.error) {
                                const email = profileResponse.email;
                                const name = profileResponse.name;

                                this.setState({
                                    email: {
                                        value: email,
                                        error: null,
                                    },
                                    name: {
                                        value: name,
                                        error: null,
                                    },
                                    signup_method: 'facebook',
                                });

                                // Attempt login first, will proceed to signup if member not found
                                this.props.userLogin({
                                    sso: 'facebook',
                                    credential: response.authResponse.accessToken,
                                    user_id: response.authResponse.userID,
                                    email: email,
                                    fromSignup: true,
                                });
                            }
                        }
                    );
                }
            }, { scope: 'public_profile,email' });
        }
    }

    appleSignup = () => {
        this.props.trackCustomEvent({
            event_name: 'sign_up_start',
            params: {
                devcat: this.devcat,
                ctx: this.ctx,
                meth: 'apple',
            },
        });

        if (window.AppleID && window.AppleID.auth) {
            window.AppleID.auth.signIn()
                .then((response) => {
                    if (response && response.authorization) {
                        let email = null;
                        let name = null;
                        if (response.user) {
                            const userInfo = response.user;
                            email = userInfo.email || '';
                            name = userInfo.name ?
                                `${userInfo.name.firstName || ''} ${userInfo.name.lastName || ''}`.trim() : '';
                        } else {
                            // this normally happens if the user has already approved the app in the past,
                            // unlikely to happen in the real world
                            const responsePayload = this.decodeJwtResponse(response.authorization.id_token);
                            email = responsePayload.email;
                        }

                        this.setState({
                            email: {
                                value: email,
                                error: null,
                            },
                            name: {
                                value: name,
                                error: null,
                            },
                            signup_method: 'apple',
                        });

                        // Attempt login first, will proceed to signup if member not found
                        this.props.userLogin({
                            sso: 'apple',
                            credential: response.authorization.id_token,
                            email: email,
                            fromSignup: true,
                        });
                    }
                })
                .catch((error) => {
                    this.props.trackCustomEvent({
                        event_name: 'sign_up_error',
                        params: {
                            devcat: this.devcat,
                            ctx: this.ctx,
                            meth: 'apple',
                            error_type: JSON.stringify(error.error),
                        },
                    });
                });
        }
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    emailError: state.user && state.user.emailError,
    passwordError: state.user && typeof state.user.passwordError === 'boolean'
        ? 'Password did not match this email'
        : state.user.passwordError,
    google: state.google,
    apple: state.apple,
    phoneNumberError: state.user && state.user.phoneNumberError,
    product: state.product,
    signupIntent: state['signup-intent'],
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackCustomEvent: (payload) => dispatch({ type: 'ga:custom_event', payload: payload }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
    userSignup: (payload) => dispatch({ type: 'user:signup-api', payload: payload }),
    userLogin: (payload) => dispatch({ type: 'user:login', payload: payload }),
    updateInterests: (payload) => dispatch({ type: 'member:update-interests', payload: payload }),
    optIn: (payload) => dispatch({ type: 'sms:opt-in', payload: payload }),
    routeTo: (route) => dispatch({ type: 'route:to', payload: route }),
    updateProduct: (payload) => dispatch({ type: 'product:update', payload: payload }),
    clearSignupIntent: () => dispatch({ type: 'signup-intent:clear' }),
    setSignupIntent: (payload) => dispatch({ type: 'signup-intent:set', payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
